module.exports = __webpack_public_path__ + "static/monikawork7-b823a7ea05c60e26533ba3c36a6287c6.jpg";